import { useNavigate } from "react-router-dom";
import { DoorOpen } from "lucide-react";

// The Tavern Story — shown as step two of the Welcome flow (Welcome → Story → Home).
// Completing the flow (Step Inside) records the visit in localStorage.
export default function Story() {
  const navigate = useNavigate();

  const stepInside = () => {
    try { localStorage.setItem("tavern_welcomed", "true"); } catch (e) { /* private mode */ }
    navigate("/");
  };

  return (
    <div
      data-testid="story-page"
      className="flex items-center justify-center px-4 py-10 md:py-16"
      style={{
        minHeight: "100svh",
        background: "radial-gradient(circle at 50% 10%, #1a0a2e 0%, #0c0613 100%)",
      }}
    >
      <article className="parchment-card fade-in w-full max-w-[760px] p-7 md:p-12" data-testid="story-card">
        <div className="text-center">
          <div className="page-eyebrow" style={{ fontSize: "0.7rem" }}>the tavern story</div>
          <h1 className="tavern-heading gold-text mt-2" style={{ fontSize: "clamp(2.2rem, 6vw, 3.4rem)", lineHeight: 1.05 }}>
            The Lanterns Are Lit
          </h1>
          <div className="tavern-script text-xl mt-2" style={{ color: "var(--orchid-light)" }}>✦</div>
        </div>

        <div
          className="mt-8 space-y-5"
          style={{ color: "var(--silver)", fontSize: "1.075rem", lineHeight: 1.85 }}
        >
          <p style={{ textIndent: 0 }}>
            The Tavern did not begin with a grand plan.<br />
            It began with curiosity.
          </p>
          <p>
            A love of old stories, forgotten histories, strange worlds, beautiful art, late-night games,
            and all the little things that make people stop and say, wait… tell me more.
          </p>
          <p>
            Over time, those interests gathered together like travelers arriving from different roads.
            Gaming sat beside history. Art found a place near folklore. Stories wandered in from distant
            places. Music, photographs, ideas, odd facts, and quiet observations all found a chair by the fire.
          </p>
          <p>Eventually, it became clear they needed a home.</p>
          <p>
            And so The Lanterns Are Lit was created—a small digital tavern for the curious, the creative,
            the wandering, and anyone who has ever stayed up far too late following a fascinating thought
            down an unexpected path.
          </p>
          <p>
            There is no single purpose here beyond sharing what brings a little wonder into the world.
            Some days that may be history. Other days, a game, a piece of art, a strange bit of lore,
            a photograph, a story, or something discovered entirely by accident.
          </p>
          <p>This is a place to explore, create, learn, and occasionally get wonderfully distracted.</p>
          <p>
            You do not need to know the right password.<br />
            You do not need to belong to any particular crowd.<br />
            If something here makes you curious, makes you smile, or sends you off to discover something new,
            then you have already found your place at the table.
          </p>

          <div className="text-center tavern-script text-2xl pt-2" style={{ color: "var(--orchid-light)" }}>
            <p style={{ lineHeight: 1.5, margin: 0 }}>
              The fire is warm.<br />
              The kettle is on.<br />
              And the lanterns are lit.<br />
              Stay as long as you like.
            </p>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <button className="gold-btn glow-pulse" onClick={stepInside} data-testid="story-step-inside">
            <DoorOpen className="h-4 w-4" /> Step Inside
          </button>
        </div>
      </article>
    </div>
  );
}
